module.exports = __webpack_public_path__ + "static/media/onlineStore.d167b27c.png";